module.exports = __webpack_public_path__ + "static/image 3-9fbe6eee15df15edade0546b436713bb.png";